<template>
  <div>
    <template v-if="loading">
      <!-- TODO: loading spinner: not while php is also rendering alerts in the same parent block -->
    </template>

    <div v-else-if="compliances.length" v-cloak class="m-b-20">
      <div v-for="compliance in compliances" :key="compliance.name">
        <UsContractTypeCompanyAlert
          v-if="compliance.name === 'US_CONTRACT_TYPE'"
          :hire-id="hireId"
          :completed="compliance.data.determination.completed"
          :contract-type-label="compliance.data.determination.contractTypeLabel"
          :has-bills="compliance.data.hasBills"
        />
        <GlobalContractTypeCompanyAlert
          v-if="compliance.name === 'GLOBAL_CONTRACT_TYPE'"
          :hire-id="hireId"
          :completed="compliance.data.determination.completed"
          :contract-type-label="compliance.data.determination.contractTypeLabel"
          :has-bills="compliance.data.hasBills"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import UsContractTypeCompanyAlert from '@/components/compliances/alerts/UsContractTypeCompanyAlert.vue'
import GlobalContractTypeCompanyAlert from '@/components/compliances/alerts/GlobalContractTypeCompanyAlert.vue'
import { ACTIVE_COMPLIANCES_ON_HIRE_FRAGMENT } from '@/components/compliances/queries/Compliances'
import { ParseJSONPropertyInObject } from '@/utils/ParseJSONPropertyInObject'

const props = defineProps({
  hireId: {
    type: Number,
    required: true,
  },
})

const complianceNames = ['US_CONTRACT_TYPE', 'GLOBAL_CONTRACT_TYPE']

const { result, loading } = useQuery(
  gql`
    query getHireCompliances($hireId: Int!, $complianceNames: [ComplianceName!]!) {
      hire(localId: $hireId) {
        ...ActiveCompliancesOnHire
      }
    }
    ${ACTIVE_COMPLIANCES_ON_HIRE_FRAGMENT}
  `,
  {
    hireId: props.hireId,
    complianceNames,
  },
)
const compliances = computed(
  () =>
    result.value?.hire?.compliances
      ?.filter((compliance) => compliance.isApplicable)
      ?.map((compliance) => ParseJSONPropertyInObject('data', compliance)) || [],
)
</script>
